import React from 'react';
import {observer} from 'mobx-react';
import Dropdown from 'core/components/Dropdown.js';
import Checkbox from 'core/components/Checkbox.js';
import Button from 'core/components/Button.js';
import {HospitalDirectoryStoreContext} from 'core/stores/RootStore.js';

export default
@observer
class HospitalDirectoryHeader extends React.Component {
    static contextType = HospitalDirectoryStoreContext;

    renderFilter() {
        const {
            rootStore: {
                healthFundStore: {hasHFRLoaded},
            },
            filteredHospitalRelationships,
            filterByHealthFundRelationship,
            updateFilterParams,
            healthFundDisclaimer,
        } = this.context;
        return (
            <>
                <span
                    dangerouslySetInnerHTML={{
                        __html: healthFundDisclaimer,
                    }}
                ></span>
                {filteredHospitalRelationships?.map((hfr) => {
                    return (
                        <Checkbox
                            checked={hfr.checked}
                            className={'filter'}
                            disabled={!hasHFRLoaded}
                            key={hfr.id}
                            name={hfr.name}
                            onChange={() =>
                                filterByHealthFundRelationship(hfr.id)
                            }
                            type="checkbox"
                        >
                            {hfr.displayName}
                        </Checkbox>
                    );
                })}
                <Button
                    action={updateFilterParams}
                    customClass="cta"
                    isPreventDefault={true}
                    text={'Update search'}
                    type="submit"
                />
            </>
        );
    }

    renderDropDown() {
        const {
            rootStore: {
                healthFundStore: {healthFund},
                paramStore: {hasSkin},
            },
            healthFundFilterText,
            filteredHospitalRelationships,
            hfrDropdownHandler,
            isHFRDropdownOpen,
        } = this.context;
        if (
            !healthFund?.id ||
            filteredHospitalRelationships?.length <= 2 ||
            hasSkin
        ) {
            return null;
        }
        return (
            <section className="filters">
                <form className="no-skin">
                    <Dropdown
                        displayText={healthFundFilterText}
                        handleToggle={(status) => hfrDropdownHandler(status)}
                        storeIsOpen={isHFRDropdownOpen}
                    >
                        {this.renderFilter()}
                    </Dropdown>
                </form>
            </section>
        );
    }

    render() {
        const {
            rootStore: {
                paramStore: {isClient},
            },
        } = this.context;
        return (
            <header className="directory-header">
                {!isClient && <h1>{this.context.headingString}</h1>}
                {this.renderDropDown()}
            </header>
        );
    }
}
